const state = () => ({
  subDomainConfig:{
    backgroundColor:'white'
  },
})
export default state
